// extracted by mini-css-extract-plugin
export var center = "_44-2";
export var clickableRow = "_44-5";
export var expandedRow = "_44-7";
export var hoverable = "_44-4";
export var left = "_44-1";
export var right = "_44-3";
export var row = "_44-0";
export var selectedRow = "_44-6";
export var summaryRow = "_44-8";